import requestModule from '@/assets/libs/requestModule'

export default {
  state: {
    selectedEvent: null,
    eventMessage: null,
    events: null
  },
  mutations: {
    setEventsMessage (state, message) {
      state.eventMessage = message
    },
    setEvents (state, events) {
      state.events = events
    },
    setSelectedEvent (state, selectedEvent) {
      state.selectedEvent = selectedEvent
    }
  },
  actions: {
    async loadEvents ({ commit }) {
      try {
        const events = await requestModule.postRequest('event/search', {}, null, 'get')
        commit('setEvents', events.data)
        commit('setEventsMessage', events.message)
      } catch (error) {
        console.log(error)
      }
    },
    updateSelectedEvent ({ commit }, data) {
      commit('setSelectedEvent', data)
    }
  },
  getters: {
    getEvents: state => state.events,
    getEventsMessage: state => state.eventMessage,
    getCurrentEvent: (state) => state.selectedEvent
  }
}
